var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 57.9,
    viewBox: "0 0 60 57.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21191",
    "data-name": "Path 21191",
    d: "M78,74.9H75.3V31.2a2.006,2.006,0,0,0-2-2H53.1V23a2.006,2.006,0,0,0-2-2H26.7a2.006,2.006,0,0,0-2,2V74.9H22a2,2,0,0,0,0,4H78a2,2,0,0,0,0-4Zm-36.9,0H36.6V58h4.5Zm8-43.7V74.9H45.2V56a2.006,2.006,0,0,0-2-2H34.7a2.006,2.006,0,0,0-2,2V75H28.8V25.1H49.2v6.1Zm22.2,8.5H61.1a2,2,0,0,0,0,4H71.3V49H61.1a2,2,0,0,0,0,4H71.3v5.4H61.1a2,2,0,0,0,0,4H71.3v5.4H61.1a2,2,0,0,0,0,4H71.3V75H53.1V33.2H71.4v6.5Z",
    transform: "translate(-20 -21)",
    fill: "#d8d8d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgIcon);
export default __webpack_public_path__ + "static/media/org_icon.0705fb8e733024cc861c046d1e73bac5.svg";
export { ForwardRef as ReactComponent };